import { SIERRA_PERSONA_MAP } from '../constants.ts';

import {
    type SupportChatTouchpoint,
    type PreChatFields,
    type SupportChatEndUserType,
} from '../../types.ts';

type SierraVariables = PreChatFields & {
    touchpoint: SupportChatTouchpoint;
    persona: SupportChatEndUserType;
    isAgentAvailable: 'true' | 'false';
};

function getSierraVariables({
    touchpoint,
    isLiveAgentAvailable,
    preChatFields,
}: {
    touchpoint: SupportChatTouchpoint;
    isLiveAgentAvailable: boolean;
    preChatFields: PreChatFields;
}): SierraVariables {
    return {
        ...preChatFields,
        touchpoint,
        persona: SIERRA_PERSONA_MAP[touchpoint],
        isAgentAvailable: isLiveAgentAvailable ? 'true' : 'false',
    };
}

export { getSierraVariables };
